module.exports = "/assets/landing-korw/how-it-works/step_1.png?z7Pi63N";